<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/adminUserManagement"
        >Admin User Management</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">Admin User</h3>
    <div class="detailContent">
      <div class="requireRmarks">*Required Fields</div>
      <el-form
        label-width="180px"
        label-position="left"
        ref="formAccount"
        :model="formAccount"
        :rules="formAccountRules"
      >
        <el-row>
          <h4>User Information</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Name">
              <el-select
                v-model="formAccount.Name"
                @change="changeUserLevel"
                disabled
              >
                <el-option
                  v-for="(item, index) in userList"
                  :key="index"
                  :label="item.fullName"
                  :value="item.employeeId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Last Name">
              <el-input
                v-model="formAccount.lastName"
                maxlength="50"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="First Name">
              <el-input
                v-model="formAccount.firstName"
                maxlength="50"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Email address" prop="email">
              <el-input
                v-model="formAccount.email"
                maxlength="50"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Password" prop="pwd">
              <el-input v-model="formAccount.pwd" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-divider></el-divider>
        <el-row>
          <h4>Permission</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Level" prop="userLevel">
              <el-select
                v-model="formAccount.userLevel"
                @change="changeUserLevel"
              >
                <el-option
                  v-for="(item, index) in userLevelList"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Sales Office" prop="salesOffice">
              <el-select
                v-model="formAccount.salesOffice"
                @change="changeSalesOffice"
                :disabled="isSalesOfficeDisabled"
              >
                <el-option
                  v-for="(item, index) in salesOfficeListFiltered"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item
              label="Region"
              prop="regions"
              style="text-align: left"
            >
              <el-checkbox-group
                v-model="formAccount.regions"
                :disabled="isRegionsDisabled"
              >
                <el-checkbox
                  :label="item.code"
                  v-for="(item, index) in regionListFiltered"
                  :key="index"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- {{ checkTypeList }} -->
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Permisson">
              <div class="table-box">
                <el-row class="table-head">
                  <el-col :span="8"
                    ><div class="Module"><p>Module</p></div></el-col
                  >
                  <el-col :span="16">
                    <el-row class="vu">
                      <el-col :span="12"
                        ><div class="View"><p>View</p></div></el-col
                      >
                      <el-col :span="12"
                        ><div class="Update"><p>Update</p></div></el-col
                      >
                    </el-row>
                  </el-col>
                </el-row>

                <el-row v-for="(item, i) in tableData" class="table-body">
                  <el-col :span="8"
                    ><div class="Module">
                      <p>{{ item.name }}</p>
                    </div></el-col
                  >
                  <el-col :span="16">
                    <el-row>
                      <el-checkbox-group
                        style="height: 100%"
                        v-model="checkTypeList"
                        @change="handleCheckAllChange"
                      >
                        <el-col
                          class="checkbox"
                          :span="12"
                          v-for="(code, index) in item.codes"
                        >
                          <el-checkbox
                            :label="code"
                            @change="handleCheckedCitiesChange"
                            ><p class="none">none</p></el-checkbox
                          >
                        </el-col>
                      </el-checkbox-group>
                    </el-row>
                  </el-col>
                </el-row>

                <!-- <div>
                  <el-checkbox-group v-model="checkTypeList">
                    <el-checkbox
                      class="checkbox"
                      :label="item"
                      v-for="(item, index) in tableData[i].codes"
                      :key="index"
                      ><p class="none">none</p></el-checkbox
                    >
                  </el-checkbox-group>
                </div> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button
          v-if="showSave"
          class="reset"
          style="width: 100%"
          @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          type="primary"
          style="width: 100%"
          @click="handleSave"
          v-if="showSave"
          >Save</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  cmsUserDetails,
  getSalesOffice,
  getSalesRegion,
  cmsUserEdit,
  cmsPermissions,
  employeesCmsuser,
} from "@/request/api";
export default {
  name: "cmsEditUser",
  data() {
    return {
      formAccountRules: this.$validation.cmsUserEdit,
      formAccount: {
        id: "",
        userLevel: "",
        salesOffice: "",
        regions: [],
        firstName: "",
        lastName: "",
        initial: "",
        email: "",
        Name: "",
      },
      checkTypeList: [],
      tableData: [],
      userList: [],
      salesOfficeFullList: [],
      // salesOfficeList:[],
      regionFullList: [],
      // regionList:[],
      userLevelList: [
        { name: "Level 1", code: "SUPER_ADMIN" },
        { name: "Level 2", code: "CS_TEAM" },
        { name: "Level 3", code: "SALES_TEAM" },
      ],
      prevRoute: null,
      showSave: true,
      checkPermission: [],
      isCheck: false,
    };
  },
  computed: {
    isSalesOfficeDisabled() {
      return this.formAccount.userLevel === "SUPER_ADMIN";
    },
    isRegionsDisabled() {
      return (
        this.formAccount.userLevel === "SUPER_ADMIN" ||
        this.formAccount.userLevel === "CS_TEAM"
      );
    },
    salesOfficeListFiltered() {
      if (this.formAccount.userLevel === "SUPER_ADMIN") {
        return this.salesOfficeFullList;
      } else {
        return this.salesOfficeFullList.filter((s) => s.code != "All");
      }
    },
    regionListFiltered() {
      if (
        !this.formAccount.salesOffice ||
        this.formAccount.salesOffice === "All"
      ) {
        return this.regionFullList;
      } else {
        return this.regionFullList.filter(
          (r) => r.salesOfficeCode === this.formAccount.salesOffice
        );
      }
    },
  },
  methods: {
    handleCheckedCitiesChange(item) {
      this.isCheck = item;
    },

    handleCheckAllChange(val) {
      this.checkPermission.forEach((code) => {
        var isRead = false;
        if (this.isCheck) {
          if (
            !val.find((item) => item === code + "READ") &&
            val.find((item) => item === code + "WRITE")
          ) {
            this.checkTypeList.push(code + "READ");
          }
        } else {
          if (
            !val.find((item) => item === code + "READ") &&
            val.find((item) => item === code + "WRITE")
          ) {
            this.checkTypeList.forEach((item, index) => {
              if (item === code + "WRITE") {
                this.checkTypeList.splice(index, 1);
              }
            });
          }
        }
      });
    },
    getDetails() {
      console.log(this.$route.params.id);
      cmsUserDetails(this.$route.params.id).then((res) => {
        const dbData = res.data.payload;
        this.formAccount.id = dbData.id;
        this.formAccount.employeeId = dbData.employeeId;
        this.formAccount.userLevel = dbData.userLevel;
        this.formAccount.regions = dbData.regions;
        this.formAccount.firstName = dbData.firstName;
        this.formAccount.lastName = dbData.lastName;
        this.formAccount.initial = dbData.initial;
        this.formAccount.email = dbData.email;
        this.checkTypeList = dbData.permissions;
        this.formAccount.Name = dbData.firstName + "," + dbData.lastName;
        if (dbData.userLevel === "SUPER_ADMIN") {
          this.formAccount.salesOffice = "All";
        } else {
          this.formAccount.salesOffice = dbData.salesOffices[0];
        }
      });
    },

    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },

    getFilterConfig() {
      getSalesOffice().then((res) => {
        const salesOfficeList = res.data.payload;
        salesOfficeList.unshift({ name: "All", code: "All" });
        this.salesOfficeFullList = JSON.parse(JSON.stringify(salesOfficeList));
      });
      getSalesRegion("").then((res) => {
        this.regionFullList = JSON.parse(JSON.stringify(res.data.payload));
      });
    },
    changeUserLevel(v) {
      if (v === "SUPER_ADMIN") {
        this.$set(this.formAccount, "salesOffice", "All");
        this.changeSalesOffice();
      } else if (v === "CS_TEAM") {
        this.$set(this.formAccount, "salesOffice", "");
      }
    },
    changeSalesOffice() {
      this.$set(this.formAccount, "regions", []);
      if (this.formAccount.userLevel !== "SALES_TEAM") {
        this.$set(
          this.formAccount,
          "regions",
          this.regionListFiltered.map((r) => r.code)
        );
      }
    },
    handleCancel() {
      this.$router.push("/adminUserManagement");
    },
    handleSave() {
      this.$refs.formAccount.validate((valid) => {
        console.log("submit ", this.formAccount);
        if (valid) {
          let params = {
            permissionCode: this.checkTypeList,
            regions: this.formAccount.regions,
            salesOffices: [this.formAccount.salesOffice],
            userLevel: this.formAccount.userLevel,
          };
          cmsUserEdit(this.formAccount.id, params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("The changes have been saved");
              this.$router.push({
                name: "cmsUser",
                params: {
                  update: true,
                },
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.error(
            "Please check the form and fill in correct format"
          );
        }
      });
    },
    Employees() {
      employeesCmsuser().then((res) => {
        console.log(res);
        const data = res.data.payload;
        this.userList = data;
      });
    },
    Permissions() {
      cmsPermissions().then((res) => {
        console.log(res);
        const data = res.data.payload;
        this.tableData = data;
        data.forEach((item) => {
          this.checkPermission.push(item.codes[0].split("READ")[0]);
        });
        console.log(this.checkPermission);
      });
    },
    getSelect() {
      setTimeout(() => {
        console.log(this.userList);
        console.log(this.formAccount);
        var sel = null;
        sel = this.userList.filter(
          (item) => item.employeeId == this.formAccount.employeeId
        );
        console.log(sel);
        if (sel[0]) {
          this.formAccount.Name = sel[0].employeeId;
        }
      }, 1000);
    },
  },

  created: function () {
    this.Employees();
    this.Permissions();
    this.getDetails();
    this.getFilterConfig();
    this.showBtn("CMS_USER_WRITE");
  },
  mounted: function () {
    this.getSelect();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "cmsUser") {
      this.prevRoute.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.table-box {
}
.table-head {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.none {
  display: none;
}

.checkbox {
  text-align: center;
  display: flex;
  margin: 0;
  border-left: 1px solid #ebeef5;
  align-items: center;
  justify-content: center;
}

.Module p {
  padding: 12px 10px;
  text-align: center;
}
.vu {
  display: flex;
  overflow: hidden;
}
.View {
  text-align: center;
  border-left: 1px solid #ebeef5;
}
.Update {
  text-align: center;
  border-left: 1px solid #ebeef5;
}
.View p {
  padding: 12px 0px;
}
.Update p {
  padding: 12px 0px;
}
.table-body {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}
.table-body p {
  padding: 12px 10px;
}
.el-checkbox-group {
  display: flex;
  overflow: hidden;
}

.el-row {
  margin-bottom: 0;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/cmsUser/editUser.vue